import { Typography } from 'antd';
import { memo } from 'react';

import Utils from 'utils/utils';

import { useTranslate } from 'hooks';

type TableValueProps = {
	value: string | null | number;
	isAmount?: boolean;
	isPenalties?: boolean;
};

export const TableValue = memo(({ value, isAmount, isPenalties }: TableValueProps) => {
	const t = useTranslate(['notSetYetText', 'notSetText']);
	return value === null ? (
		<Typography.Text type="secondary">
			<>{isPenalties ? t.notSetText : t.notSetYetText}</>
		</Typography.Text>
	) : (
		<>{isAmount ? Utils.moneyFormat(+value) : value}</>
	);
});
